import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_BADWORD } from './router';

menuRegistry.registerMenu([
    {
        parent: 'General',
        key: 'BadWord',
        name: 'Bad Word',
        icon: 'fas fa-grimace',
        route: { name: ROUTE_NAME_BADWORD }
    }
]);

export default registerRouteForModule(router);
